module.exports = __webpack_public_path__ + "media/images/vp/icon.addtask.white-18ccf0c2ae625bd24c4c139b5795dc08.svg";